/** The FusionAuth application role that grants admin-console access. */
export const ADMIN_ROLE = "admin";

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(normalized)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join(""),
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/** Read the `roles` array claim from a FusionAuth access token. */
export function getRoles(token: string | null | undefined): string[] {
  if (!token) return [];
  const decoded = decodeJwtPayload(token);
  const roles = decoded?.roles;
  return Array.isArray(roles) ? (roles as string[]) : [];
}

/**
 * UX-only admin check from the signed JWT `roles` claim. NOTE: this is NOT the
 * security boundary — every admin GraphQL query must itself carry
 * `[Authorize(Roles = new[] { "admin" })]`. See §3 of admin/docs/dashboard-agents.md.
 */
export function isAdmin(token: string | null | undefined): boolean {
  return getRoles(token).includes(ADMIN_ROLE);
}
